import { DialogFlag } from 'common/types/allocation';
import { ReducerAction, ReducerState } from 'common/types/reducers';

/**
 * @function
 * @name showCompanyDrawer
 * @description reducer for action.
 * @param {Object} state  - reducer state
 * @param {Object} action - action context
 * @return {OBJECT} Action context
 */
export const showCompanyDialog = (state: ReducerState, action: ReducerAction<{ openCompanyDialog: boolean }>) => ({
  ...state,
  ...action,
});

/**
 * @function
 * @name showCompanyDrawerForEdit
 * @description reducer for action.
 * @param {Object} state  - reducer state
 * @param {Object} action - action context
 * @return {OBJECT} Action context
 */
export const showCompanyDialogForEdit = (
  state: ReducerState,
  action: ReducerAction<{ openCompanyDialog: boolean; showCompanyDialogForEdit: boolean }>
) => ({
  ...state,
  ...action,
});

/**
 * @function
 * @name showFirmDrawer
 * @description reducer for action.
 * @param {Object} state  - reducer state
 * @param {Object} action - action context
 * @return {OBJECT} Action context
 */
export const showFirmDrawer = (state: ReducerState, action: ReducerAction<{ openFirmDrawer: boolean }>) => ({
  ...state,
  ...action,
});

export const showAllocationDrawer = (
  state: ReducerState,
  action: ReducerAction<{ openAllocationDrawer: boolean }>
) => ({
  ...state,
  ...action,
});
/**
 * @function
 * @name showCaptableDrawer
 * @description reducer for action.
 * @param {Object} state  - reducer state
 * @param {Object} action - action context
 * @return {OBJECT} Action context
 */
export const showCaptableDrawer = (state: ReducerState, action: ReducerAction<{ openCaptableDrawer: boolean }>) => ({
  ...state,
  ...action,
});
/**
 * @function
 * @name showLoadingProgress
 * @description reducer for action.
 * @param {Object} state  - reducer state
 * @param {Object} action - action context
 * @return {OBJECT} Action context
 */
export const showLoadingProgress = (
  state: ReducerState,
  action: ReducerAction<{ isShowLoadingProgress: boolean }>
) => ({
  ...state,
  ...action,
});

export const showFirmStepper = (state: ReducerState, action: ReducerAction<{ isFirmStepperVisible: boolean }>) => ({
  ...state,
  ...action,
});

export const showMeasurementDatesLedger = (
  state: ReducerState,
  action: ReducerAction<{ isShowMeasurementDatesLedger: boolean }>
) => ({
  ...state,
  ...action,
});
export const showApproachDialog = (state: ReducerState, action: ReducerAction<{ openApproachDialog: boolean }>) => ({
  ...state,
  ...action,
});

export const setDialogFlag = (state: ReducerState, action: ReducerAction<{ dialogFlag: DialogFlag }>) => ({
  ...state,
  ...action,
});

export const setFieldAttributes = (state: ReducerState, action: ReducerAction<{ fieldAttributes: unknown }>) => ({
  ...state,
  ...action,
});
